import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ArticleSwiper from '../../components/Article_Swiper';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import './travel.css';
import TravelCardImage from '../../components/travel_card_image';
import { CustomTypoH1, CustomTypoH2 } from '../../helper/headings';
import TravelPartner from '../../components/travel_partner';
import BottomSignupGradient from '../../components/bottom_signup_gradient';
import FAQTabs from '../../components/Accordion';

// SVG
import TravelSec1SVG from '../../assets/travel/travel_1.svg';
import TravelSec2SVG from '../../assets/travel/travel_2.svg';
import TravelSec1DSVG from '../../assets/travel/travel_1d.svg';
import TravelSec2DSVG from '../../assets/travel/travel_2d.svg';
import TravelSec3DSVG from '../../assets/travel/travel_3d.svg';
import AppNavBar from '../../helper/appbar';


const Travel = () => {
    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    return (
        <main className='travel_main'>
            <AppNavBar navType={'dark'} />
            <section className='s_travel_section_1'>
                <Container fluid>
                    <Row>
                        <Col sm={12} lg={6}>
                            <h3>Travel solution for every business.</h3>
                            <p>The largest inventory you can find. Grow your business through business travel with Kardinal. </p>
                            <button onClick={freeSignUp}>Sign up for free<ChevronRightIcon /></button>
                            <ul>
                                <img src={require("../../assets/travel/fidson_travel.png")} alt="travel_brands" />
                                <img src={require("../../assets/travel/parthian_travel.png")} alt="travel_brands" />
                                <img src={require("../../assets/travel/sec1_ro_travel.png")} alt="travel_brands" />
                                <img src={require("../../assets/travel/jnci.png")} alt="travel_brands" />
                            </ul>
                        </Col>
                        <Col sm={12} lg={6}>
                            <img src={TravelSec1SVG} alt="travel_sec1" loading='lazy' />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='s_travel_section_2'>
                <h5>Simple, affordable, flexible business travel solution.</h5>
                <img src={TravelSec2SVG} alt="travel_sec2" loading='lazy' />
                <aside>
                    <h5>Simple, affordable, flexible business travel solution.</h5>
                    <section>
                        <ArticleSwiper spaceBetween={18} slidesPerView={2} />
                        <ArticleSwiper spaceBetween={0} slidesPerView={1} />
                    </section>
                </aside>
            </section>

            <section className='s_travel-section_3'>
                <CustomTypoH2 typo={"The solution for every need"} />
                <article>
                    <TravelCardImage
                        snap={TravelSec1DSVG}
                        title={"Industry"}
                        description={"The travel solution for every industry. Leverage the right tool for your business travel, whether you're in entertainment, energy, NGOs, finance, or FMCG."}
                    />
                    <TravelCardImage
                        snap={TravelSec2DSVG}
                        title={"Executive Service"}
                        description={`Charter services for business executives, entertainment professionals, or anyone really.`}
                    />
                    <TravelCardImage
                        snap={TravelSec3DSVG}
                        title={"Bleisure"}
                        description={`Add more silver lining to your work. Enjoy the best of both worlds; business and leisure travel all in one place.`}
                    />
                </article>
            </section>

            {/* Section 4th */}
            <TravelPartner />

            {/* Section 5th */}
            <BottomSignupGradient
                type={`Get full control on your business travel.`}
            />

            {/* Section 5th */}
            <section className='s_travel_section6'>
                <CustomTypoH1 typo={`Your concerns, answered.`} />
                <FAQTabs activeKey={0} />
            </section>
        </main>
    );
};
export default Travel;